export const COMPOSITION_PREFIX = 'compositionTypes';

export const COMPOSITION_TYPES = {
    ROOT: `${COMPOSITION_PREFIX}.root`,
    CHAPTER_MENU: {
        TITLE: `${COMPOSITION_PREFIX}.chapterMenu.title`,
        TITLE_ACCENT: `${COMPOSITION_PREFIX}.chapterMenu.titleAccent`,
        CLOSE: `${COMPOSITION_PREFIX}.chapterMenu.close`,
        LIST: `${COMPOSITION_PREFIX}.chapterMenu.list`,
        LIST_ITEM: `${COMPOSITION_PREFIX}.chapterMenu.listItem`,
        LIST_ITEM_LABEL: `${COMPOSITION_PREFIX}.chapterMenu.listItemLabel`,
        LIST_ITEM_TIME: `${COMPOSITION_PREFIX}.chapterMenu.listItemTime`
    },
    QUIZ: {
        SECTION_TITLE: `${COMPOSITION_PREFIX}.quiz.sectionTitle`,
        SECTION_DESCRIPTION: `${COMPOSITION_PREFIX}.quiz.sectionDescription`,
        QUESTION_TITLE: `${COMPOSITION_PREFIX}.quiz.questionTitle`,
        QUESTION_DESCRIPTION: `${COMPOSITION_PREFIX}.quiz.questionDescription`,
        ANSWER: `${COMPOSITION_PREFIX}.quiz.answer`,
        BUTTON: `${COMPOSITION_PREFIX}.quiz.button`,
        PROGRESS: `${COMPOSITION_PREFIX}.quiz.progress`,
        MESSAGE_FINAL: `${COMPOSITION_PREFIX}.quiz.messageFinal`,
        CONTROL_BAR_EXPAND: `${COMPOSITION_PREFIX}.quiz.controlBarExpandButton`,
        CONTROL_BAR_COLLAPSE: `${COMPOSITION_PREFIX}.quiz.controlBarCollapseButton`
     },
    ISI: {
        DOWNLOAD_LINK: `${COMPOSITION_PREFIX}.isi.downloadLink`,
        CONTROL_BAR: `${COMPOSITION_PREFIX}.isi.controlBar`,        
        CONTROL_BAR_EXPAND: `${COMPOSITION_PREFIX}.isi.controlBarExpandButton`,
        CONTROL_BAR_COLLAPSE: `${COMPOSITION_PREFIX}.isi.controlBarCollapseButton`
    },
    CONTENT_EXPLORER: {
        SEARCH_BAR: `${COMPOSITION_PREFIX}.contentExplorer.searchBar`,
        SEARCH_INPUT: `${COMPOSITION_PREFIX}.contentExplorer.searchInput`,
        LIST: `${COMPOSITION_PREFIX}.contentExplorer.list`,
        LIST_ITEM: `${COMPOSITION_PREFIX}.contentExplorer.listItem`
    },
    INFO_PANEL: {
        TITLE: `${COMPOSITION_PREFIX}.infoPanel.title`,
        IMAGE: `${COMPOSITION_PREFIX}.infoPanel.image`,
        CLOSE: `${COMPOSITION_PREFIX}.infoPanel.close`,
        CONTENT: `${COMPOSITION_PREFIX}.infoPanel.content`,
    },
    BRANCH_SELECTOR: {
        CONTENT: `${COMPOSITION_PREFIX}.branchSelector.content`,
        IMAGE: `${COMPOSITION_PREFIX}.branchSelector.image`
    },
    IMAGE: {
        CONTROL_BAR: `${COMPOSITION_PREFIX}.image.controlBar`,
        CONTROL_BAR_EXPAND: `${COMPOSITION_PREFIX}.image.controlBarExpandButton`,
        CONTROL_BAR_COLLAPSE: `${COMPOSITION_PREFIX}.image.controlBarCollapseButton`
    },
    IFRAME: {
        CONTROL_BAR: `${COMPOSITION_PREFIX}.iframe.controlBar`,
        CONTROL_BAR_EXPAND: `${COMPOSITION_PREFIX}.iframe.controlBarExpandButton`,
        CONTROL_BAR_COLLAPSE: `${COMPOSITION_PREFIX}.iframe.controlBarCollapseButton`
    },
    POP: {
        CONTROL_BAR: `${COMPOSITION_PREFIX}.pop.controlBar`,
        CONTROL_BAR_EXPAND: `${COMPOSITION_PREFIX}.pop.controlBarExpandButton`,
        CONTROL_BAR_COLLAPSE: `${COMPOSITION_PREFIX}.pop.controlBarCollapseButton`
    },
    FORM: {
        HEADER: `${COMPOSITION_PREFIX}.form.header`,
        PARAGRAPH: `${COMPOSITION_PREFIX}.form.paragraph`,
        BUTTON: `${COMPOSITION_PREFIX}.form.button`,
        BUTTON_SUBMIT: `${COMPOSITION_PREFIX}.form.buttonSubmit`,
        LABEL: `${COMPOSITION_PREFIX}.form.label`,
        INPUT: `${COMPOSITION_PREFIX}.form.input`,
        INPUT_TEXT: `${COMPOSITION_PREFIX}.form.inputText`,
        INPUT_DATE: `${COMPOSITION_PREFIX}.form.inputDate`,
        INPUT_FILE: `${COMPOSITION_PREFIX}.form.inputFile`,
        INPUT_CHECKBOX: `${COMPOSITION_PREFIX}.form.inputCheckbox`,
        INPUT_NUMBER: `${COMPOSITION_PREFIX}.form.inputNumber`,
        INPUT_RADIO: `${COMPOSITION_PREFIX}.form.inputRadio`,
        TEXTAREA: `${COMPOSITION_PREFIX}.form.textarea`,
        SELECT: `${COMPOSITION_PREFIX}.form.select`,
        CONFIRM_SCREEN: `${COMPOSITION_PREFIX}.form.confirmScreen`,
        CONFIRM_PROMPT: `${COMPOSITION_PREFIX}.form.confirmPrompt`,
        CONFIRM_BUTTON: `${COMPOSITION_PREFIX}.form.confirmButton`,
        CONTROL_BAR: `${COMPOSITION_PREFIX}.form.controlBar`,
        CONTROL_BAR_EXPAND: `${COMPOSITION_PREFIX}.form.controlBarExpandButton`,
        CONTROL_BAR_COLLAPSE: `${COMPOSITION_PREFIX}.form.controlBarCollapseButton`
    }
};

export const STYLE_PROPS = {
    COLOR: 'styleProps.color',
    BACKGROUND_COLOR: 'styleProps.backgroundColor',
    BORDER_TOP: 'styleProps.borderTop',
    BORDER_BOTTOM: 'styleProps.borderBottom',
    BORDER_LEFT: 'styleProps.borderLeft',
    BORDER_RIGHT: 'styleProps.borderRight',
    FONT_SIZE: 'stylesProps.fontSize',
    FONT_WEIGHT: 'styleProps.fontWeight',
    PADDING: 'styleProps.padding',
    LIST_STYLE: 'styleProps.listStyle',
    PADDING_TOP: 'styleProps.paddingTop',
    PADDING_BOTTOM: 'styleProps.paddingBottom',
    PADDING_LEFT: 'styleProps.paddingLeft',
    PADDING_RIGHT: 'styleProps.paddingRight',
    OPACITY: 'styleProps.opacity',
    BORDER_RADIUS: 'styleProps.borderRadius',
    FLOAT: 'styleProps.float'
};

export const ALL_STYLES = Object.values(STYLE_PROPS);

export const BEHAVIORS = {
    CLICK: 'behaviors.click',
    ENTER: 'behaviors.enter',
    EXIT: 'behaviors.exit'
};

export const ALL_BEHAVIORS = Object.values(BEHAVIORS);

export const STATES = {
    EXPANDED: 'expanded'
};

export const COMPOSITIONS = {
    SIMPLE: {
        IDENTIFIER: COMPOSITION_TYPES.ROOT,
        STYLES: ALL_STYLES,
        BEHAVIORS: ALL_BEHAVIORS,
        STATES: {}
    }
};

export const getCompositionInfo = compositionName => {
    return [
        { ...COMPOSITIONS.SIMPLE, STATES },
        ...Object
            .values(COMPOSITION_TYPES[compositionName])
            .map(v => ({
                IDENTIFIER: v,
                STYLES: ALL_STYLES,
                BEHAVIORS: BEHAVIORS.CLICK,
                STATES
            }))
    ];
}

export const ACTIONS = {
    GO_TO_TIME: 'toTime',
    GO_TO_START: 'toStart',
    GO_TO_END: 'toEnd',
    GO_TO_SEEK_START: 'toSeekStart',
    GO_TO_LINK: 'toLink',
    GO_TO_NEXT: 'toNext',
    GO_TO_PREV: 'toPrevious',
    GO_TO_ANNOTATION: 'toAnnotation',
    PAUSE: 'pause',
    PLAY: 'play',
    SET_VARIABLES: 'setVariables',
    RELEASE_GATE: 'releaseGate',
    APPLY_GATE: 'applyGate',
    ENABLE_SEEK: 'enableSeek',
    DISABLE_SEEK: 'disableSeek',
    EXPAND_TARGET: 'expandTarget',
    COLLAPSE_TARGET: 'collapseTarget',
    SET_LANGUAGE: 'setLanguage',
    SEND_DATA: 'sendData',
    CONFIRM_ACTION: 'confirmAction',
    REMOVE_ANNOTATION: 'removeAnnotation',
    SHOW_ANNOTATION: 'showAnnotation',
    HIDE_ANNOTATION: 'hideAnnotation',
    TOGGLE_ANNOTATION: 'toggleAnnotation',
    APPLY_STYLE: 'applyStyle',
    SET_PANEL: 'setPanel',
    UPDATE_SCORE: 'updateScore',
    ADD_CLASS: 'addClass',
    REMOVE_CLASS: 'removeClass',
    SET_CLASS: 'setClass',
    SUBMIT_FORM: 'submitForm',
    RESET_FORM: 'resetForm',
    RETRY_QUIZ: 'retryQuiz',
    COMPLETE_QUIZ: 'completeQuiz',
    SET_LEVEL: 'setLevel',
    ENTER_FULLSCREEN: 'enterFullscreen',
    EXIT_FULLSCREEN: 'exitFullscreen',
    RESET_ACTIVITIES: 'resetActivities'
};

export const TIME_ACTIONS = [
    ACTIONS.GO_TO_TIME,
    ACTIONS.GO_TO_START,
    ACTIONS.GO_TO_END,
    ACTIONS.GO_TO_SEEK_START
];

export const PASSIVE_EVENTS = [
    'atStartTime',
    'atEndTime',
    'onActivate', 
    'onDeactivate'
];

export const KNOWN_BUTTON_INTENTS = {
    BACK_BUTTON: 'Back Button',
    NEXT_BUTTON: 'Next Button',
    RETRY_BUTTON: 'Retry Button',
    SUBMIT_BUTTON: 'Submit Button',
    CONFIRMATION_BUTTON: 'Confirmation Button'
}

export const STATIC_ANNOTATION_TYPES = {
    CONTROLS: 'controls',
    CLOSED_CAPTIONS: 'closedcaptions',
    MUTE_TOGGLE: 'mute',
    DEFINTION_PROVIDER: 'definitionprovider',
    PROGRESS_INDICATOR: 'progressindicator',
    AUDIO_DESCRIPTION: 'audiodescription'
};

export const BEHAVIOR_MODIFIERS = {
    CONTROLS: 'controls',
    LANGUAGE_PROVIDER: 'languageprovider',
    CONDITION_PROVIDER: 'conditionalsettingsprovider',
    STYLESHEET: 'stylesheet',
    VIDEO: 'video',
    POWER_WORDS: 'powerwords'
}

export const DESCENDANTS_ONLY = {
    QUIZ_SECTION: 'quizsection',
    QUESTION: 'question',
    ANSWER: 'answer',
    PROGRESS: 'progress'
}

export const NOT_TRACKABLE_INTENTS = [
    KNOWN_BUTTON_INTENTS.BACK_BUTTON,
    KNOWN_BUTTON_INTENTS.NEXT_BUTTON,
    KNOWN_BUTTON_INTENTS.SUBMIT_BUTTON,
    KNOWN_BUTTON_INTENTS.RETRY_BUTTON,
    KNOWN_BUTTON_INTENTS.CONFIRMATION_BUTTON,
    'Final Message',
    'Passing Message',
    'Failing Message'
]

export const NOT_TRACKABLE_ANNOTATIONS = [
    ...Object.values(STATIC_ANNOTATION_TYPES),
    ...Object.values(BEHAVIOR_MODIFIERS),
    ...Object.values(DESCENDANTS_ONLY)
]

export const isAnnotationTrackable = ({
    type = '',
    intent = '',
    properties = {}
}) => (
    !NOT_TRACKABLE_ANNOTATIONS.includes(type) &&
    !NOT_TRACKABLE_INTENTS.includes(intent) &&
    !properties.localized
)

export const EXPANDABLE_PLAYER_ANNOTATIONS = [
    "richText", 
    "iframe",
    "image"
]

export const ANSWER_TYPES = {
    MULTIPLE_CHOICE: 'multiple-choice',
    CHECKBOX: 'checkbox',
    BOOLEAN: 'boolean',
    LINEAR_SCALE: 'linear-scale',
    OPEN_RESPONSE: 'open-response',
    ANNOTATION: 'annotation'
}

export const POINT_ALLOCATION_RULES = {
    ANY_CORRECT: 'any-correct',
    ALL_CORRECT: 'all-correct'
}

export const ANSWER_STATUS = {
    NOT_ANSWERED: 'notAnswered',
    ANSWERED_CORRECTLY: 'answeredCorrectly',
    ANSWERED_INCORRECTLY: 'answeredIncorrectly'
}

export const SERIALIZABLE_PROPS = [
    'id',
    'content',
    'type',
    'start',
    'end',
    'target',
    'actions',
    'properties',
    'styles',
    'toolType',
    'variations'
];

export const LIFECYCLES = {
    INACTIVE: 'inactive',
    VISITED: 'visited',
    INTERACTED: 'interacted',
    SUCCESS: 'success',
    FAILED: 'failed'
}

export const LIFECYCLE_ORDER = [
    LIFECYCLES.INACTIVE,
    LIFECYCLES.VISITED,
    LIFECYCLES.INTERACTED,
    LIFECYCLES.SUCCESS,
    LIFECYCLES.FAILED
]

export const AT_TIME_MARGIN_SECONDS = 0.25;